const config = {
  BASE_API_URL: `${process.env.NEXT_PUBLIC_TV}/api/v2`,
  TIME_REQUEST_HOME_PAGE: 10 * 60 * 1000,
  TIME_REQUEST_VIDEO: 5 * 1000,
  TIME_REQUEST_CATEGORY: 120 * 1000
}

export default config
